import {
  ConfirmSimulation,
  ConfirmSimulationData,
} from "@src/Steps/receive/confirmSimulation/ConfirmSimulation";
import {
  AvantDePoursuivre,
  AvantDePoursuivreData,
} from "@src/Steps/subscribe/avantDePoursuivre/AvantDePoursuivre";
import {
  Beneficiaires,
  BeneficiairesData,
} from "@src/Steps/subscribe/beneficiaires/Beneficiaires";
import {
  CheckYourMail,
  CheckYourMailData,
} from "@src/Steps/subscribe/checkYourMail/CheckYourMail";
import { Consent, ConsentData } from "@src/Steps/subscribe/consents/Consent";
import {
  ConsentSouscription,
  ConsentSouscriptionData,
} from "@src/Steps/subscribe/consentSouscription/ConsentSouscription";
import {
  MandatPrelevement,
  MandatPrelevementData,
} from "@src/Steps/subscribe/mandatPrelevement/MandatPrelevement";
import { NumSecu, NumSecuData } from "@src/Steps/subscribe/numSecu/NumSecu";
import {
  PiecesJustificatives,
  PiecesJustificativesData,
} from "@src/Steps/subscribe/piecesJustificatives/PiecesJustificatives";
import {
  PolitiquementExposee,
  PolitiquementExposeeData,
} from "@src/Steps/subscribe/politiquementExposee/PolitiquementExposee";
import {
  RecapSignature,
  RecapSignatureData,
} from "@src/Steps/subscribe/recapSignature/RecapSignature";
import {
  RecapSouscription,
  RecapSouscriptionData,
} from "@src/Steps/subscribe/recapSouscription/RecapSouscription";
import {
  SubscriptionIntroduction,
  SubscriptionIntroductionData,
} from "@src/Steps/subscribe/subscriptionIntroduction/SubscriptionIntroduction";
import { Success, SuccessData } from "@src/Steps/subscribe/sucess/Success";
import {
  ValidatePoints,
  ValidatePointsData,
} from "@src/Steps/subscribe/validatePoints/ValidatePoints";
import { Dispatch, SetStateAction } from "react";
import { Tip } from "@src/Tip";
import {
  ProjetPreSouscription,
  ProjetSignature,
  ProjetSouscription,
} from "@src/App";
import {
  BirthDate,
  BirthDateData,
} from "@src/Steps/simulate/birthDate/BirthDate";
import { Landing, LandingData } from "@src/Steps/simulate/landing/Landing";
import {
  Situation,
  SituationData,
} from "@src/Steps/simulate/situation/Situation";
import {
  Activities,
  ActivitiesData,
} from "@src/Steps/simulate/activities/Activities";
import { Tarif } from "@src/Steps/simulate/tarif/Tarif";
import {
  ContactInfos,
  ContactInfosData,
} from "@src/Steps/receive/contactInfos/ContactInfos";
import {
  AddressInfos,
  AddressInfosData,
} from "@src/Steps/receive/addressInfos/AddressInfos";
import { Recap, RecapData } from "@src/Steps/receive/recap/Recap";

export type StepProps<TData> = {
  projectId?: string;
  projetSouscription?: ProjetSouscription;
  projetPreSouscription?: ProjetPreSouscription;
  projetSignature?: ProjetSignature;
  setProjetSignature: Dispatch<SetStateAction<ProjetSignature | undefined>>;
  setProjetPreSouscription: Dispatch<
    SetStateAction<ProjetPreSouscription | undefined>
  >;
  data: TData;
  changeStep: (
    stepName: StepName,
    transitionDirection: "forward" | "backward"
  ) => void;
  setData: (data: TData) => void;
  stepsData: StepsData;
};

export enum MacroStep {
  Simulate,
  Receive,
  Subscribe,
}

export enum MicroStep {
  PersonalInformation,
  Payment,
  SupportingDocuments,
  Signature,
}

export type StepsType = {
  progress: number | undefined;
  component: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  tipsComponent: (() => JSX.Element) | null;
  minifiedSidePane: boolean;
  macroStep: MacroStep;
};

export const STEPS: Record<string, StepsType> = {
  LANDING: {
    progress: undefined,
    component: Landing,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Simulate,
  },
  SITUATION: {
    progress: 10,
    component: Situation,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Simulate,
  },
  BIRTHDATE: {
    progress: 20,
    component: BirthDate,
    tipsComponent: Tip,
    minifiedSidePane: false,
    macroStep: MacroStep.Simulate,
  },
  ACTIVITIES: {
    progress: 30,
    component: Activities,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Simulate,
  },
  TARIF: {
    progress: 40,
    component: Tarif,
    tipsComponent: null,
    minifiedSidePane: true,
    macroStep: MacroStep.Simulate,
  },
  CONTACT_INFOS: {
    progress: 50,
    component: ContactInfos,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Receive,
  },
  ADDRESS_INFOS: {
    progress: 60,
    component: AddressInfos,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Receive,
  },
  RECAP: {
    progress: 70,
    component: Recap,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Receive,
  },
  CONFIRMATION_SIMULATION: {
    progress: 80,
    component: ConfirmSimulation,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Receive,
  },
  SUBSCRIPTION_INTRODUCTION: {
    progress: undefined,
    component: SubscriptionIntroduction,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  VALIDATE_POINTS: {
    progress: 25,
    component: ValidatePoints,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  CHECK_YOUR_MAIL: {
    progress: 75,
    component: CheckYourMail,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  RECAP_SOUSCRIPTION: {
    progress: undefined,
    component: RecapSouscription,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  CONSENT: {
    progress: undefined,
    component: Consent,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  AVANT_DE_POURSUIVRE: {
    progress: undefined,
    component: AvantDePoursuivre,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  NUM_SECU: {
    progress: undefined,
    component: NumSecu,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  POLITIQUEMENT_EXPOSEE: {
    progress: undefined,
    component: PolitiquementExposee,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  BENEFICIAIRES: {
    progress: undefined,
    component: Beneficiaires,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  CONSENT_SOUSCRIPTION: {
    progress: undefined,
    component: ConsentSouscription,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  MANDAT_PRELEVEMENT: {
    progress: undefined,
    component: MandatPrelevement,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  PIECES_JUSTIFICATIVES: {
    progress: undefined,
    component: PiecesJustificatives,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  RECAP_SIGNATURE: {
    progress: undefined,
    component: RecapSignature,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
  SUCCESS: {
    progress: undefined,
    component: Success,
    tipsComponent: null,
    minifiedSidePane: false,
    macroStep: MacroStep.Subscribe,
  },
};

export type StepsData = {
  LANDING: LandingData;
  BIRTHDATE: BirthDateData;
  SITUATION: SituationData;
  ACTIVITIES: ActivitiesData;
  TARIF: Tarif;
  CONTACT_INFOS: ContactInfosData;
  ADDRESS_INFOS: AddressInfosData;
  RECAP: RecapData;
  CONFIRMATION_SIMULATION: ConfirmSimulationData;
  SUBSCRIPTION_INTRODUCTION: SubscriptionIntroductionData;
  VALIDATE_POINTS?: ValidatePointsData;
  CONSENT: ConsentData;
  CHECK_YOUR_MAIL: CheckYourMailData;
  RECAP_SOUSCRIPTION: RecapSouscriptionData;
  AVANT_DE_POURSUIVRE: AvantDePoursuivreData;
  NUM_SECU: NumSecuData;
  POLITIQUEMENT_EXPOSEE: PolitiquementExposeeData;
  BENEFICIAIRES: BeneficiairesData;
  CONSENT_SOUSCRIPTION: ConsentSouscriptionData;
  MANDAT_PRELEVEMENT: MandatPrelevementData;
  PIECES_JUSTIFICATIVES: PiecesJustificativesData;
  RECAP_SIGNATURE: RecapSignatureData;
  SUCCESS: SuccessData;
};

export type StepName = keyof typeof STEPS;

export type ActivitiesProps = {
  sports: boolean;
  cycling: boolean;
  hiking: boolean;
  cooking: boolean;
  gardening: boolean;
  handiwork: boolean;
  outings: boolean;
};
